export default {
    first_name: "",
    last_name: "",
    email: "",
    contact_no: "",
    profile_image_url: "",
    address: "",

    agreed_to_eula: "No",
    agreed_to_eula_timestamp: "",
    account_created: "",
    last_active: "",

    access_level: "Level 4",
    security_level: "Admin",
    deleted: false
};
